import React from 'react';
import { InputWrapper, FieldContainer, FloatingLabel, StyledInput, ErrorMessage } from './styles';

export default function TextInput({ name, value, onChange, onBlur, error, placeholder, disabled, maxLength }) {
  const hasValue = !!value;

  return (
    <InputWrapper>
      <FieldContainer $hasError={!!error} $disabled={disabled}>
        {hasValue && <FloatingLabel>{placeholder}</FloatingLabel>}
        <StyledInput
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={hasValue ? '' : placeholder}
          disabled={disabled}
          $hasValue={hasValue}
          maxLength={maxLength}
          autoComplete="off"
        />
      </FieldContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
}
